var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVmSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H9V15H15V9Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H11V6H13V2Z",
    fill: "#7986CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H7V6H9V2Z",
    fill: "#7986CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H15V6H17V2Z",
    fill: "#7986CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18H11V22H13V18Z",
    fill: "#3F51B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H7V22H9V18Z",
    fill: "#3F51B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H15V22H17V18Z",
    fill: "#3F51B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11V13H22V11H18Z",
    fill: "#3F51B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V17H22V15H18Z",
    fill: "#3F51B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7V9H22V7H18Z",
    fill: "#3F51B5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11V13H6V11H2Z",
    fill: "#7986CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15V17H6V15H2Z",
    fill: "#7986CB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7V9H6V7H2Z",
    fill: "#7986CB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V19H19V5H5ZM17 17H7V7H17V17Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H15L12 12L9 15Z",
    fill: "#7986CB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L15 15V9L12 12Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmSelected);
export default __webpack_public_path__ + "static/media/vm_selected.736ecec5148ced72ca96e642fd9da1f9.svg";
export { ForwardRef as ReactComponent };